import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubTitle } from "../stores/AppReducer";
import { IChatMessage } from "../interfaces/App";
import { addMessage, getMessageByDay, getThreads, uploadImage } from "../services/apiService";
import Calendar from "./Calendar";
import ThreadList from "./ThreadList";
import { checkRights } from "../core/Helper";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";

function Chat() {
    const dispatch = useDispatch<AppDispatch>();
    const app = useSelector((appState: IApplicationState) => appState.app);
    const fileRef: React.RefObject<HTMLInputElement> = React.createRef();
    const times = useRef(0);
    const [message, setMessage] = useState("");
    const [threadIdx, setThreadIdx] = useState(null);
    const [date, setDate] = useState(new Date());
    const [bigImage, setBigImage] = useState(null);


    useEffect(() => {
        if (times.current++ === 0) {
            dispatch(setSubTitle("Chat"));
            dispatch(getThreads(app.user.id));
            setDate(new Date());
            // setCurrentDate(new Date())
        }
    }, []);
    useEffect(() => {
        if (!threadIdx && app.threads?.length > 0) {
            setThreadIdx(0);
        }
    }, [app.threads]);
    useEffect(() => {
        if (app.threads?.length > 0 && threadIdx !== null) {
            // const newDate = new Date().toISOString().split("T")[0];
            dispatch(getMessageByDay({threadId: app.threads[threadIdx].threadId, date: null}));
        }
    }, [threadIdx]);

    const getMessages = (newDate: string) => {
        dispatch(getMessageByDay({threadId: app.threads[threadIdx].threadId, date: newDate}));
    };
    const handleAddMessage = (ev: any) => {
        ev.preventDefault();
        dispatch(addMessage({id: app.user.id, threadId: app.threads[threadIdx].threadId, message})).then((res: any) => {
            if (res.type === "post/addMessage/fulfilled") {
                setMessage("");
            }
        });
    };
    const handleUploadImage = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        const file: File = ev.target.files[0];
        dispatch(uploadImage({
                path: 'chat/',
                file, 
                big: 1200,
                thumb: 300,
                type: "image",
                userId: app.user.id,
                threadId: app.threads[threadIdx].threadId,
            }));
    };
    const switchBigImage = (thumbnail: string) => {
        if (bigImage) {
            setBigImage(null);
        } else {
            const temp = thumbnail?.replace(/\?t_/, "?b_");
            setBigImage(temp);
        }
    };

    const renderThread = (msg: IChatMessage, idx: number) => {
        if (!msg.message) {
            const dateString = new Date(msg.timestamp).toISOString().split("T")[0];
            return (
                <div key={"msgLink_" + idx} className="sys">
                    <span onClick={() => getMessages(dateString)}>{msg.timestamp.toLocaleDateString()}</span>
                </div>
            );
        } else {
            const dir = msg.id === app.user.id ? "in" : "out";
            return (
                <div key={"msg_" + idx} className={dir} onClick={msg.media ? () => switchBigImage(msg.message) : null}>
                    <div>{msg.name}: {msg.timestamp.toLocaleTimeString()}</div>
                    <span 
                        dangerouslySetInnerHTML={{__html: bigImage ? bigImage : msg.message}} 
                        className={bigImage ? "fullScreenImage" : "thumbnail"}
                        onClick={() => switchBigImage(null)}
                    />
                </div>
            );
        }
    };
    const renderChatForm = () => {
        return app.threads?.length > 0 ?
        (
            <form onSubmit={(ev: any) => handleAddMessage(ev)} >
                <div className="message">
                    <textarea
                        name = "data"
                        required = {true}
                        placeholder = "Nachricht"
                        maxLength = {256}
                        autoFocus = {true}
                        onChange = {(ev: any) => setMessage(ev.currentTarget.value)}
                        value = {message}
                        className = "" 
                    />
                    <div>
                        <input
                            type="file"
                            style={{display: "none"}}
                            ref={fileRef}
                            onChange={(ev: any) => handleUploadImage(ev)}
                        /> 
                        <button
                            className = "uploadBtn"
                            onClick={() => fileRef.current.click()}
                        >
                            &#128247;
                        </button>
                        <input
                            type = 'submit'
                            id = 'submit'
                            value = '>'
                            className = "submit"
                        /> 
                    </div>
                </div>
            </form>
        ) : (null);
    };
    return (
        <div id="app" className="home">
            <ThreadList onChange={setThreadIdx} currentThread={threadIdx}/>
            <Calendar
                date={date}
                days={threadIdx !== null ? app.threads[threadIdx].days : []}
                getMessages={(iso: string) => getMessages(iso)}
                setDate={setDate}
                className="calendar_side"
            />
            <div className="chatBox">
                <div id = 'content'>
                    {(app.threads?.length && app.threads[threadIdx]) && app.threads[threadIdx].thread.map(renderThread)}
                    <div className="clear" />
                </div>
                {checkRights(app.user, "chatWrite") && renderChatForm()}
            </div>
            <div className="clear"/>
        </div>
    );
}
export default (Chat);
